import { action as apiAction } from 'api/Api'
import {
  add as addActivity
} from '../redux/activities'
import { optimisticDispatch } from 'utils/sagas'

type Payload = {
  cardId: number
  message: any
  emails: string[]
}

const requestSendMessage = (payload: Payload) => async (dispatch, getState) => {
  const { cardId, message, emails } = payload

  const tempId = `temp-${new Date().getTime()}`

  const state = getState()

  const boardId = state['view-board'].cards[cardId].boardId
  const currentUserId = state.kanbo.currentUser.id

  const optimisticAction = optimisticDispatch(dispatch, addActivity({
    cardId,
    activity: {
      id: tempId,
      from: `u:${currentUserId}`,
      timestamp: Date.now(),
      tags: ['important', 'message'],
      data: {
        action: 'SendEmailFromCard',
        rtMessage: message,
        cardId,
        boardId
      },
      isBusy: true
    }
  }))

  try {
    await apiAction('SendEmailFromCard', {
      cardId,
      rtMessage: message,
      to: emails
    })
  } finally {
    optimisticAction.revert()
  }
}

export default requestSendMessage
